module.exports = __webpack_public_path__ + "static/media/frutta_guscio.6dfbb6b9.svg";